import type { MostViewedParams } from "../api/ProjectAPI.types";

export const DEFAULT_MOST_VIEWED_ITEM_TYPE: MostViewedParams["itemType"] =
  "media";
